<template>   
    <b-card-text>
        <b-row class="mb-1">
            <b-col sm="12">
                <b-button @click="add()" type="button" variant="link" class="list-view-icon-btn list-view-icon-btn--primary float-right" v-b-tooltip.hover title="Agregar Condición de Pago" aria-label="Agregar Condición de Pago">
                    <AppIcon name="add" />
                </b-button>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col>
                <b-table class="app-table mb-0"
                        stacked="md"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.items"
                        :fields="table.fields"
                        :filter="table.filter"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        v-if="table.items.length">

                    <template v-slot:cell(id)="data">
                        <b>{{ data.item.id }}</b>
                    </template>

                    <template v-slot:cell(name)="data">
                        {{ data.item.name }}
                    </template>
                    
                    <template v-slot:cell(term)="data">      
                        <h5>                  
                            <b-badge v-if="data.item.term" variant="secondary">{{ data.item.term }} DIAS</b-badge>
                            <b-badge v-else variant="secondary">0 DIAS</b-badge>
                        </h5>
                    </template>

                    <template v-slot:cell(surcharge)="data">
                        <span v-if="parseFloat(data.item.surcharge)>0">{{ parseFloat(data.item.surcharge) }}%</span>                        
                        <span v-else><i>SIN RECARGO</i></span>
                    </template>

                    <template v-slot:cell(f_action)="data">
                        <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle">
                            <template #button-content><AppIcon name="more_vert" label="Opciones" /><span class="app-table-action-label">Opciones</span></template>
                            <b-dropdown-header>Acciones</b-dropdown-header>                                                           
                            
                            <b-dropdown-item @click="edit(data.item)">
                                <AppIcon name="edit" class="mr-1" /> Editar
                            </b-dropdown-item>
                            <b-dropdown-item @click="remove(data.item)">
                                <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>
                </b-table>
                <EmptyState v-else icon="payments" title="No hay condiciones de pago" description="Agregá una condición para usarla al generar comprobantes." />
            </b-col>
        </b-row>
                            
        <b-row>
            <b-col>
                <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                    <AppIcon name="back" class="mr-1" />
                    Volver
                </b-button>                        
            </b-col>

            <b-col>
                <nav>
                <b-pagination class="pull-right mb-0"
                                size="sm"
                                pills=""
                                :total-rows="getRowCount(table.items)"
                                :per-page="table.perPage"
                                v-model="table.currentPage" />
                </nav>
            </b-col> 
        </b-row>            

        <!-- ########################### -->
        <!-- #####     MODALES     ##### -->
        <!-- ########################### -->

        <b-modal v-model="modal.form.active"
                body-class="app-modal-form"
                :key="modal.form._id"
                :id="modal.form._id">                    
            <div slot="modal-header" minimize class="app-modal-header">
                <span class="app-modal-header__icon"><AppIcon name="payments" /></span>
                <h5 class="app-modal-header__title">{{ modal.form.title }}</h5>
            </div>

            <b-row>
                <b-col md="12">
                    <b-form-group label="Condición de Pago">
                        <b-form-input type="text"
                                        size="sm"
                                        v-model="crud.form.name"
                                        required>
                        </b-form-input>
                    </b-form-group>
                </b-col>                    
            </b-row>

            <b-row>
                <b-col md="12">
                    <b-form-group label="Plazo">
                        <b-form-input type="number"
                                        size="sm"
                                        v-model="crud.form.term"
                                        required>
                        </b-form-input>
                    </b-form-group>
                </b-col>
                
                <b-col md="12">
                    <b-form-group label="Recargo">
                      <b-input-group size="sm" append="%">
                        <b-form-input type="number"
                                        size="sm"
                                        v-model="crud.form.surcharge"
                                        required>
                        </b-form-input>
                      </b-input-group>
                    </b-form-group>
                </b-col>                
            </b-row>

            <div slot="modal-footer">
                <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false"><AppIcon name="x" class="mr-1" />Cancelar</b-button>
                <b-button variant="primary" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
            </div>
        </b-modal>
    
    </b-card-text>                                
</template>

<script>
    import serviceAPI from './../services'
    import Error from '@/handler/error'

    export default {
        data: () => {
            return {      
                table : {
                    items: [],
                    fields: [
                        {key: 'id', label: 'ID', sortable: true, class:"align-middle"},
                        {key: 'name', label: 'Nombre', class:"align-middle"},
                        {key: 'term', label: 'Plazo', class:"align-middle text-center"},
                        {key: 'surcharge', label: 'Recargo', class:"align-middle text-center"},
                        {key: 'f_action', label:'', class:"align-middle"},
                    ],                    
                    currentPage: 1,
                    perPage: 50,
                },
                crud: {
                    form: {
                        id: 0,
                        name: '',
                        term: 0,
                        surcharge: 0,
                    },
                },
                modal: {
                    form: {
                        active: false,
                        title: ''
                    },
                },
            }
        },
        mounted () {
            this.show()
        },
        methods: {
            getRowCount (items) {
                return items.length
            },
            show() {        
                var result = serviceAPI.obtenerMetodosPagos()

                result.then((response) => {
                    var data = response.data
                    this.table.items = data
                })
                .catch(error => {
                    this.$awn.alert(Error.showError(error))
                });  
            },
            add() {
                this.crud.form.id = 0                
                this.crud.form.name = ''
                this.crud.form.term = 0
                this.crud.form.surcharge = 0

                this.modal.form._id = Math.random().toString(36).slice(2, 8)
                this.modal.form.title = "Nueva Condición de Pago"
                this.modal.form.active = true
            },
            edit(item) {                
                this.crud.form.id = item.id
                this.crud.form.name = item.name
                this.crud.form.term = item.term ? item.term : 0
                this.crud.form.surcharge = item.surcharge ? item.surcharge : 0

                this.modal.form._id = Math.random().toString(36).slice(2, 8)
                this.modal.form.title = "Editar Condición de Pago"
                this.modal.form.active = true
            },
            remove(item) {
                this.crud.form.id = item.id
                this.crud.form.name = item.name
                this.crud.form.term = item.term

                this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
                    title: 'Borrar Condición de Pago',
                    size: 'lg',
                    buttonSize: 'lg',
                    okVariant: 'danger',
                    okTitle: 'SI',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    headerBgVariant: 'danger',
                    headerTextVariant: 'white',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        let loader = this.$loading.show();
                        var result = serviceAPI.eliminarMetodosPagos(this.crud.form.id);

                        result.then((response) => {      
                            this.modal.form.active = false        
                            loader.hide()
                            this.show()
                            this.$awn.success("Registro eliminado");
                        })
                        .catch(error => {
                            loader.hide()
                            this.$awn.alert(Error.showError(error));
                        })
                    }
                })
                .catch(error => {
                    this.$awn.alert(Error.showError(error));
                })
            },
            save() {
                let loader = this.$loading.show();
                if (this.crud.form.id) {
                    var result = serviceAPI.editarMetodosPagos(this.crud.form);
                } else {
                    var result = serviceAPI.agregarMetodosPagos(this.crud.form);
                }

                result.then((response) => {
                    this.modal.form.active = false
                    loader.hide()
                    this.show()
                    this.$awn.success("Datos guardados con éxito");
                })
                .catch(error => {
                    loader.hide()
                    this.$awn.alert(Error.showError(error));
                })
            },
        } 
    }
</script>
